import type {
  ENotificationStatus,
  ENotificationSubject,
} from '@/stores/store.constante';

export class DefaultEntityDto {
  id?: string;
  createdAt?: string;
  updatedAt?: string;
  lockedAt?: string;
  disabledAt?: string;
}

export class JwtTokenEntity {
  accessToken: string;
  refreshToken: string;
}

export class NotificationSetting {
  showDelay?: boolean;
  showReady?: boolean;
  showToValidate?: boolean;
}

export class JwtDecodedEntity {
  /** userId */
  sub: string;

  /** `username` */
  user_ref: string;

  /** user email */
  user_email: string;

  /** restaurantId */
  restaurant_ref: string;

  /** user permissions */
  scope: string[];

  /** `user type` : `staff` , `client` , `customer`*/
  // ref: "staff" | "client" | "customer";

  /** `token type` : "access" | "refresh"*/
  type: 'access' | 'refresh';

  /** issue at */
  iat: number;

  /** expire at */
  exp: number;
}

export class StaffEntity extends DefaultEntityDto {
  username?: string;
  email?: string;
  fullname?: string;
}

export enum EStoreThreadStatus {
  LOADING = 'loading',
  ERROR = 'error',
  SUCCESS = 'success',
}
export class StoreThread<ActionType = any> {
  status: EStoreThreadStatus;
  type: ActionType;
  id: string;
  payload?: any;
  message?: { content: string; display: boolean };
}

export enum EPickupMethod {
  TAKEAWAY = 'takeaway',
  DINE_IN = 'dine_in',
}

export enum EPaymentMethod {
  ONLINE = 'online',
  CASH = 'cash',
  CREDIT_CARD = 'credit_card',
}
export enum EPaymentStatus {
  PAID = 'paid',
  PAYMENT_PENDING = 'payment_pending',
  REFUNDED = 'refunded',
}
export enum EOrderStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  READY = 'ready',
  SERVED = 'served',
  COMPLETED = 'completed',
  TERMINATED = 'terminated',
  CANCELLED = 'cancelled',
  REJECTED = 'rejected',
  FAILLED = 'failled',
}
export class OrderEntityDto extends DefaultEntityDto {
  totalPrice?: number;
  orderDate?: string;
  orderNumber?: string;
  pickupMethod?: EPickupMethod;
  pickupTime?: string;
  // Présent quand le retrait planifié est une PLAGE (pickupByRange côté
  // schedules) plutôt qu'une heure précise — pickupTime porte alors le début
  // de la fenêtre, pickupTimeEnd sa fin.
  pickupTimeEnd?: string;
  paymentMethod?: EPaymentMethod;
  paymentStatus?: EPaymentStatus;
  status?: EOrderStatus;
  rejectReason?: string;
}
export class OrderItemEntityDto extends DefaultEntityDto {
  qty: number;
  unityPrice: number;
  clientNote: string;
}

export class ProductEntityDto extends DefaultEntityDto {
  designation: string;
  price: number;
  description: string;
  avalaibleAt: string;
  type: 'extra' | 'food' | 'extra&food';
}
export class ExtraMenuEntityDto extends DefaultEntityDto {
  choiceType: 'multiple' | 'unique';
  extraType: 'side-dish' | 'supplements' | 'proposal';
  required: boolean;
  title: string;
  details: { minQty: number; maxQty: number; exactQty: number };
}
export class ExtraMenuOptionsEntityDto {
  id: string;
  createdAt?: string;
  type: 'product' | 'custom';
  content: string;
  price: string;
  productId: string;
  currencyId: string;
  extraMenuId: string;
}

export class ImageEntityDto extends DefaultEntityDto {
  storageType: 'cloudinary';
  ressourceType: 'image';
  info: {
    url: string;
    assetId: string;
    publicId: string;
    secureUrl: string;
  };
  moreInfo: {
    bytes: number;
    width: number;
    format: 'png' | 'jpg';
    height: number;
  };
}

export class RestaurantEntityDto extends DefaultEntityDto {
  designation: string;
  address: string;
}

export class CurrencyEntityDto extends DefaultEntityDto {
  label: string;
  name: string;
  description: string;
}

export class CustomerEntityDto extends DefaultEntityDto {
  fname: string;
  lname: string;
}
export class ClientEntityDto extends DefaultEntityDto {
  username: string;
  email: string;
  firstname: string;
  lastname: string;
  gender: string;
  emailConfirmedAt: string;
}
export class UserEntityDto extends DefaultEntityDto {
  email?: string;
  firstname?: string;
  lastname?: string;
  gender?: string;
  emailConfirmedAt: string;
}

export class SeatEntityDto extends DefaultEntityDto {
  designation: string;
  tableNumber: number;
  tableCapacity: number;
  type: string;
}

export class PermissionEntity {
  id: string;
  name: string;
  store: string;
  organization: string;
}

export class RoleEntity {
  id: string;
  code: string;
  store: string;
  organization: string;
}

export class NotificationEntity {
  id: string;
  createdAt: string;
  staffId: string;
  orderId: string;
  subject: ENotificationSubject;
  title: string;
  content: string;
  status: ENotificationStatus;
}
